export default "__VITE_ASSET__d8fceaa8__"